import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken } from '@/utils/auth'
import { Message } from 'element-ui'
import { getTokenLogin } from "@/api";

NProgress.configure({ showSpinner: false })

const whiteList = ['/transfer', '/login', '/coke', '/coal', '/steel', '/ironstone', '/macroscopic', '/powerCoal', '/methanol', '/oilBenzene', '/cokeBenzene', '/caprolactam', '/adipic', '/dataCenter', '/styrene', '/index', '/zetar', '/anhydride', '/asphalt', '/needle', '/petroleum', '/hydrogen', '/coal/auctioNotice', '/coal/twoPage/auctioNotice']
const urlFlagList = ['coke', 'coal', 'steel', 'ironstone', 'macroscopic', 'powerCoal', 'methanol', 'oilBenzene', 'cokeBenzene', 'caprolactam', 'adipic', 'dataCenter', 'styrene', 'index', 'zetar', 'anhydride', 'asphalt', 'needle', 'petroleum', 'hydrogen']

router.beforeEach((to, from, next) => {
    const pageRouter = store.getters.pageRouter;
    if (pageRouter.length > 0) {
        routerMethods(to, from, next)
    } else {
        store.dispatch('GettPageRouter').then((res) => {
            routerMethods(to, from, next)
        })
    }
})

router.afterEach(() => {
    NProgress.done()
})

function routerMethods(to, from, next) {
    if (to.path === '/authorization') {  // 企业微信单点登录
        next()
    } else {   //  其他登录
        if (urlFlagList.includes(to.path.split('/')[1])) {
            store.commit('SET_URL_NAME', `${to.path.split('/')[1]}`)
        }
        if (to.path.split('/').includes('undefined')) {
            next(to.path.split('/')[1]);
        } else {
            next()
        }
        NProgress.start()
        setTimeout(() => {
            if (getToken()) {
                if (store.getters.roles.length === 0) {
                    // 判断当前用户是否已拉取完user_info信息
                    store.dispatch('GetInfo').then(() => {
                        next()
                        NProgress.done()
                    })
                } else {
                    NProgress.done()
                    next()
                }
            } else {
                // 没有token
                if (whiteList.indexOf(to.path) !== -1) {
                    // 在免登录白名单，直接进入
                    next()
                    NProgress.done()
                } else {
                    Message({
                        message: '未登录或登录状态已过期，请重新登录',
                        type: 'error'
                    })
                    next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
                    NProgress.done()
                }
            }
        }, 1000)
    }
}
